//3rd party packages for IE polyfills, etc
import 'core-js';//Gives us es6 native methods
import 'custom-event-polyfill';//Allows custom events in IE 11
import 'whatwg-fetch';//Gives us fetch method
import smoothscroll from 'smoothscroll-polyfill';//gives us element.scrollTo, etc
smoothscroll.polyfill();